<template>
  <div class="get-auto-consumption">
    <div class="grid-x grid-margin-x">

      <div class="small-12 cell">
        <div class="comment">
          <span v-html="comment"></span>
        </div>
      </div>
      
      <div class="small-12 medium-6 cell">
        <vue-slider v-bind="options" ref="slider" v-model="autoconsumption" @callback="call_debounced_computeWarning" @click="resizeSlider"></vue-slider>
      </div>
      <div class="small-12 medium-6 cell">
        <div class="hypothesis_autoconsumption_value">
          Taux d'autoconsommation : <strong>{{autoconsumption}}%</strong>
        </div>
        <div :class="hypothesis_label_value" ref="label">
          <span v-html="hypothesis"></span>
        </div>
      </div>

    </div>

  </div>
</template>

<script>

import vueSlider from 'vue-slider-component'
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import _ from 'lodash'
import apiClient from '@/api';


export default {
    name: 'GetAutoConsumption',
    components: {
        'vue-slider': vueSlider,
    },
    props: [
        'options',
    ],
    data () {
        return {
            comment: null,
            hypothesis: "Hypothèse réaliste.",
            hypothesis_label: "success",
            debounced_computeWarning: null,
        }
    },
    computed: {
            ...mapFields(
                [
                    'autoconsumption',
                    'power',
                ]
            ),
        hypothesis_label_value: function() {
            return `callout ${ this.hypothesis_label }`;
        },
    },
    created: function() {
        this.debounced_computeWarning = _.debounce(this.computeWarning, 700);
    },
    mounted: function() {
        // Dirty fix for resizing slider… make slider global
        window.FuckingSlider = this;
        
        // Dirty fix for resizing slider… make slider global
        $('ul#navigation-tabs.tabs').on(
          'change.zf.tabs',
          function() {
            console.log('Resize Slider');
            window.FuckingSlider.resizeSlider();
          }
        );
        
        apiClient.genericGet('/eval-rentability/autoconsumption/0/')
            .then(
                response => {
                    console.log('Got autoconsumption text', response);
                    this.comment = response.comment;
                }
            )
        .catch(error => {console.log(error)});
        

    },
    watch: {
        power: function () { this.call_debounced_computeWarning(this); },
    },
    methods: {
        resizeSlider: function() {
            this.$refs['slider'].refresh();
        },
        call_debounced_computeWarning: function(obj) {
            if (this.debounced_computeWarning != null) {
                console.log('debounce autoconsumption warging');
                this.hypothesis_label = 'wait';
                this.hypothesis = '…';
                this.debounced_computeWarning(this);
            }
        },
        computeWarning: function(obj) {
            obj.resizeSlider();

            console.log('autoconsumption-changed', obj.autoconsumption);

            apiClient.genericPost('/eval-rentability/compute-data/0/autoconsumption_warning/',
                {
                    id: 0,
                    autoconsumption_percent: obj.autoconsumption,
                    power: obj.power,
                }
            ).then(
                response => {
                    console.log('Got autoconsumption', response);
                    obj.hypothesis = response.message;
                    obj.hypothesis_label = response.label;
                }
            ).catch(error => {console.log('erre', error)});
        },
    },
}
</script>


<style scoped>
.callout.alert {
    background-color: #fff;
    color: #E00003;
    font-weight: bold;
    border: 2px solid #E00003;
    display: block;
}
.callout.warning {
    background-color: #fff;
    color: #333;
    font-weight: bold;
    border: 2px solid #ff7e07;
    display: block;
}
.callout.success {
    background-color: #fff;
    color: #008d00;
    font-weight: bold;
    border: 2px solid #008d00;
    display: block;
}
.callout.wait {
    background: none;
    color: #f8f7f5;
    font-weight: bold;
    border: 2px solid #f8f7f5;
    display: block;
}
.comment {
    margin-top: 2rem;
    margin-bottom: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/autoconsumption.vue